import { rest } from 'msw';

import { muiThemeData } from './data/muiThemeData';
import { documentRequestServiceData, uploadServiceData } from './data';

export const handlers = [
    //HTTP GET -> getDocumentRequest
    rest.get(`https://mock-document-request-api/v:version/request/:requestId`, (req, res, ctx) => {
        const { requestId } = req.params;
        return res(ctx.delay(), ctx.status(200), ctx.json(documentRequestServiceData(requestId as string)));
    }),
    //HTTP PUT -> completeDocumentRequest
    rest.put(`https://mock-document-request-api/v:version/request/:requestId/complete`, (_req, res, ctx) => {
        return res(ctx.delay(), ctx.status(200), ctx.json(true));
    }),
    //HTTP POST -> uploadDocument
    rest.post(`https://mock-document-request-api/v:version/upload/:requestId/:documentId`, (_req, res, ctx) => {
        return res(ctx.delay(), ctx.status(204));
    }),
    //HTTP DELETE -> deleteDocument
    rest.delete(`https://mock-document-request-api/v:version/upload/:requestId/:documentId/:uploadedDocumentId`, (_req, res, ctx) => {
        return res(ctx.delay(), ctx.status(204));
    }),
    //HTTP POST -> uploadFile
    rest.post(`https://mock-document-api/v:version/document/upload`, (req, res, ctx) => {
        const { file } = req.body as any;
        return res(ctx.delay(), ctx.status(200), ctx.json(uploadServiceData(file.name)));
    }),
    //HTTP DELETE -> deleteFile
    rest.delete(`https://mock-document-api/v:version/document/delete/:fileid`, (_req, res, ctx) => {
        return res(ctx.delay(), ctx.status(204));
    }),
    //HTTP GET -> getBranding
    rest.get(`https://test-brandingapi.davies-group.com/v1.0/clients/DAV/brands/GRP/react/data.json`, (_req, res, ctx) => {
        return res(ctx.delay(), ctx.status(200), ctx.json(muiThemeData()));
    }),
];
